import { DialogHeader } from './DialogHeader';

// TODO: in v9, move styled() from DialogHeader.jsx to here
export var StyledDialogHeader = DialogHeader;